import { DEFAULT_HEADER_STATE, useSetHeaderContext } from '@/layouts/MainLayout/HeaderContext'
import { OrganisationIcon } from '@/const'
import { FlatSidebarMenu } from '@/components/ui/FlatSidebarMenu'
import { useSessionStorage } from '@/hooks'
import { isSuperUser } from '@/util'
import { useCurrentProject } from './useCurrentProject'
import { getProjectNavigation } from './projectNavigation'

export function ProjectsNavMenu({ sidebarOpen = true }: { sidebarOpen?: boolean }) {
  const [roles] = useSessionStorage('roles', 0)
  const project = useCurrentProject()

  useSetHeaderContext({
    ...DEFAULT_HEADER_STATE,
    title1: project.name,
    rightTitle: project.organisation ? { text: project.organisation, icon: OrganisationIcon } : undefined,
  })

  return <FlatSidebarMenu items={getProjectNavigation(isSuperUser(roles))} sidebarOpen={sidebarOpen} />
}
